/**
 * DRAFT text pending Product/UX review.
 * Centralized here so the section headers and field hints can be updated in one place.
 */

export interface SectionDescription {
    title: string;
    description: string;
}

export const FORM_SECTION_DESCRIPTIONS: Record<
    | 'contactInformation'
    | 'orgSettings'
    | 'paymentSettings'
    | 'domainHosting'
    | 'branding'
    | 'legalAndInfoUrls'
    | 'features'
    | 'landingPageSettings',
    SectionDescription
> = {
    contactInformation: {
        title: 'Contact Information',
        description: 'Primary contact details for the person or team responsible for this payment portal.',
    },
    orgSettings: {
        title: 'Org Settings',
        description: 'Organization-level settings that identify the customer and how this app is associated with it.',
    },
    paymentSettings: {
        title: 'Payment Settings',
        description:
            'Controls how customers pay through this portal: which facilities, how many payments, and what reference information is required.',
    },
    domainHosting: {
        title: 'Domain & Hosting',
        description: 'The URL and hosting configuration where this portal will be served.',
    },
    branding: {
        title: 'Branding / UI Settings',
        description: 'Visual identity of the portal: logos, colors and other UI elements customers will see.',
    },
    legalAndInfoUrls: {
        title: 'Legal & Info URLs',
        description: 'Links to legal and informational pages (terms, privacy, support) shown in the portal.',
    },
    features: {
        title: 'Features',
        description: 'Optional features and modules you can enable or disable for this portal.',
    },
    landingPageSettings: {
        title: 'Landing Page Settings',
        description: 'Customize the appearance and welcome messaging customers see when they land on the portal.',
    },
};

export const PAYMENT_SETTINGS_FIELD_HINTS = {
    facilityId: 'Identifier of the facility that receives the payments made through this portal.',
    allowPaymentMultipleFacilities:
        'When enabled, customers can split or direct payments across more than one facility in a single session.',
    allowMultiplePayments: 'When enabled, customers can submit more than one payment in the same transaction.',
    requireCustomerReference:
        'When enabled, customers must enter a reference (e.g. account or invoice number) before paying.',
};
